module.exports = __webpack_public_path__ + "static/media/office3.a4d3b2d4.jpg";